import { FC, useState } from "react";
import FocusTrap from "focus-trap-react";
import { motion } from "framer-motion";
import { useForm, useWatch } from "react-hook-form";
import { range } from "lodash";

import { slideInFromTop } from "shared/styles/constants";
import { StyledActionDropdown } from "shared/components/ActionDropdown/styles";
import { IDate, ITheme } from "shared/types";
import { months } from "shared/constants";
import { Button, Select } from "shared/components";
import { useBreakpoint } from "shared/utils";

import { DropdownContainer, MonthContainer } from "./styles";

interface CalendarPickerDropdownProps {
  date: IDate;
  handleSubmitDate: (date: IDate) => void;
}

const YEAR_FIELD_NAME = "calendar-picker-years";

export const CalendarPickerDropdown: FC<CalendarPickerDropdownProps> = ({
  date,
  handleSubmitDate,
}) => {
  const isMobile = useBreakpoint();
  const [selectedMonth, setSelectedMonth] = useState<number>(date.month);

  const { handleSubmit, control } = useForm({
    defaultValues: {
      [YEAR_FIELD_NAME]: String(date.year),
    },
  });

  const watchAllFields = useWatch({ control });

  const years = range(date.year - 15, date.year + 15).map(year => ({
    value: String(year),
    label: String(year),
  }));

  const submitForm = (data: { [YEAR_FIELD_NAME]: string }) => {
    const newDate = {
      month: selectedMonth,
      year: +data[YEAR_FIELD_NAME] as number,
    };

    handleSubmitDate(newDate);
  };

  return (
    <FocusTrap
      focusTrapOptions={{
        allowOutsideClick: true,
      }}
    >
      <motion.div {...slideInFromTop}>
        <StyledActionDropdown noWrap overflow="visible">
          <form onSubmit={handleSubmit(submitForm)}>
            <DropdownContainer size="s" spaceDirection="horizontal" align="flex-start">
              <MonthContainer isMobile={isMobile}>
                {months.map((month, index) => (
                  <li key={`month${month}`}>
                    <Button
                      theme={selectedMonth === index ? ITheme.tertiary : ITheme.secondary}
                      size="s"
                      onClick={() => setSelectedMonth(index)}
                    >
                      {month.slice(0, 3)}
                    </Button>
                  </li>
                ))}
              </MonthContainer>
              <Select
                name={YEAR_FIELD_NAME}
                options={years}
                control={control}
                value={watchAllFields[YEAR_FIELD_NAME] as string}
              />
              <Button type="submit" onClick={handleSubmit(submitForm)}>
                Go
              </Button>
            </DropdownContainer>
          </form>
        </StyledActionDropdown>
      </motion.div>
    </FocusTrap>
  );
};
